import apiClient from "./apiService";

// Fetch categories
export const fetchCategories = async (page = 1) => {
  try {
    const response = await apiClient.get(`/admin/categories?page=${page}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get single category
export const fetchCategory = async (id) => {
  try {
    const response = await apiClient.get(`/admin/categories/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create category
export const createCategory = async (data) => {
  try {
    const response = await apiClient.post("/admin/categories", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update category
export const updateCategory = async (id, data) => {
  try {
    const response = await apiClient.put(`/admin/categories/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete category
export const deleteCategory = async (id) => {
  try {
    const response = await apiClient.delete(`/admin/categories/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
